import { Observable } from 'rxjs';

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

export const REQUEST_ID_HEADER = 'X-Request-Id';

@Injectable()
export class RequestIdInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.startsWith('/') && !request.headers.has(REQUEST_ID_HEADER)) {
      request = request.clone({
        setHeaders: { [REQUEST_ID_HEADER]: crypto.randomUUID() },
      });
    }
    return next.handle(request);
  }
}
